module.exports = __webpack_public_path__ + "static/media/visitors.e543f425.svg";